<template>
	<CStatusButton
		class="social-login__button button--no-style flex flex--align"
		:status="status"
		@click.native="handleClick"
	>
		<svg v-if="provider === 'Microsoft'" class="align" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M10.5 1.58667H1.5V10.5867H10.5V1.58667Z" fill="#F25022" />
			<path d="M10.5 11.5867H1.5V20.5867H10.5V11.5867Z" fill="#00A4EF" />
			<path d="M20.5 1.58667H11.5V10.5867H20.5V1.58667Z" fill="#7FBA00" />
			<path d="M20.5 11.5867H11.5V20.5867H20.5V11.5867Z" fill="#FFB900" />
		</svg>
		<svg v-else-if="provider === 'Google'" class="align" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
			<g fill="none" fill-rule="evenodd">
				<path d="M20.64 12.2c0-.63-.06-1.25-.16-1.84H12v3.49h4.84a4.14 4.14 0 0 1-1.8 2.71v2.26h2.92a8.78 8.78 0 0 0 2.68-6.62z" fill="#4285F4"></path>
				<path d="M12 21a8.6 8.6 0 0 0 5.96-2.18l-2.91-2.26a5.4 5.4 0 0 1-8.09-2.85h-3v2.33A9 9 0 0 0 12 21z" fill="#34A853"></path>
				<path d="M6.96 13.71a5.41 5.41 0 0 1 0-3.42V7.96h-3a9 9 0 0 0 0 8.08l3-2.33z" fill="#FBBC05"></path>
				<path d="M12 6.58c1.32 0 2.5.45 3.44 1.35l2.58-2.59A9 9 0 0 0 3.96 7.95l3 2.34A5.36 5.36 0 0 1 12 6.58z" fill="#EA4335"></path>
			</g>
		</svg>
		<Inline v-else-if="provider === 'Facebook'" svg="facebook" class="align icon--fill facebook" />
		<Inline v-else svg="images/sso-small" class="align" width="24" height="24" />

		<span class="button__text-title align ml-1">
			{{ buttonText }}
		</span>
	</CStatusButton>
</template>

<script>
	import CStatusButton from '@cognitoforms/shared-components/src/components/interaction/StatusButton.vue';
	import generateAuthorizeUrl from './open-id-connect.ts';
	import { SsoDialog } from './SsoDialog.ts';

	export default {
		name: 'ExternalAuthButton',
		components: {
			CStatusButton
		},
		props: {
			provider: { type: String, required: true },
			buttonText: { type: String, required: true },
			authenticationAction: { type: String, required: true },
			status: { type: String, default: 'default' },
			returnUrl: { type: String, default: null },
			inviteCode: { type: String, default: null },
			authMethodType: { type: String, default: null },
			requiredOrg: { type: String, default: null },
			requiredOrgName: { type: String, default: null },
			destinationOrgName: { type: String, default: null },
			requiredUser: { type: String, default: null },
			logoutReason: { type: String, default: null },
			organizationName: { type: String, default: null },
			useRedirect: { type: Boolean, default: false }
		},
		computed: {
			timezone() {
				if (this.authenticationAction === 'signup')
					return Intl.DateTimeFormat().resolvedOptions().timeZone;
				else
					return null;
			}
		},
		methods: {
			handleClick() {
				if (this.useRedirect)
					this.redirect();
				else
					this.openDialog();
			},
			/**
			 * Authenticates by redirecting to the provider
			 */
			redirect() {
				window.location.href = this.getAuthorizeUrl('redirect');
			},
			/**
			 * Authenticates in a pop-up dialog and then makes service requests via the parent component to authenticate
			 */
			openDialog() {
				const dialog = new SsoDialog(this.getAuthorizeUrl('popup'));

				dialog.onClose = this.logInCancelled;
				dialog.onFailure = this.logInError;
				dialog.onSuccess = this.logInSuccess;

				dialog.open();
			},
			getAuthorizeUrl(authenticationContext) {
				return generateAuthorizeUrl(this.authenticationAction, authenticationContext, {
					returnUrl: this.returnUrl,
					inviteCode: this.inviteCode,
					authMethodType: this.authMethodType ? this.authMethodType.toLowerCase() : null,
					requiredOrg: this.requiredOrg,
					requiredOrgName: this.requiredOrgName,
					destinationOrgName: this.destinationOrgName,
					requiredUser: this.requiredUser,
					logoutReason: this.logoutReason,
					organizationName: this.organizationName,
					timezone: this.timezone
				});
			},
			logInCancelled() {
				this.$emit('cancelled');
			},
			logInError(errorCode, errorDescription) {
				console.error(`${errorCode}: ${errorDescription}`);
				this.logInCancelled();
			},
			logInSuccess(authorizationCode) {
				this.$emit('authenticated', authorizationCode);
			}
		}
	};
</script>